/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { SVGIcon } from "@nordcloud/gnui";

export function displayYesOrNo(value: boolean) {
  switch (value) {
    case true:
      return <SVGIcon name="success" data-cy="success" />;
    case false:
      return <SVGIcon name="cancel" data-cy="cancel" />;
    default:
      return "-";
  }
}
